export enum ModalsType {

    SHOW_LOGIN_MODAL = "SHOW_LOGIN_MODAL",
    HIDE_LOGIN_MODAL = "HIDE_LOGIN_MODAL",

    SHOW_LOGOUT_MODAL = "SHOW_LOGOUT_MODAL",
    HIDE_LOGOUT_MODAL = "HIDE_LOGOUT_MODAL",

    SHOW_PROFILE_MODAL = "SHOW_PROFILE_MODAL",
    HIDE_PROFILE_MODAL = "HIDE_PROFILE_MODAL",

    SHOW_PACKAGES_MODAL = "SHOW_PACKAGES_MODAL",
    HIDE_PACKAGES_MODAL = "HIDE_PACKAGES_MODAL",

    SHOW_REPORT_MODAL = "SHOW_REPORT_MODAL",
    HIDE_REPORT_MODAL = "HIDE_REPORT_MODAL",

    HIDE_SHARE_MODAL = "HIDE_SHARE_MODAL",
    SHOW_SHARE_MODAL = "SHOW_SHARE_MODAL",

    HIDE_GIFT_MODAL = "HIDE_GIFT_MODAL",
    SHOW_GIFT_MODAL = "SHOW_GIFT_MODAL",

    SHOW_DEVICE_ACCESS_MODAL = "SHOW_DEVICE_ACCESS_MODAL",
    HIDE_DEVICE_ACCESS_MODAL = "HIDE_DEVICE_ACCESS_MODAL",

    SHOW_MESSAGE_MODAL = "SHOW_MESSAGE_MODAL",
    HIDE_MESSAGE_MODAL = "HIDE_MESSAGE_MODAL",

    SHOW_FAVORITE_MODAL = "SHOW_FAVORITE_MODAL",
    HIDE_FAVORITE_MODAL = "HIDE_FAVORITE_MODAL",

    SHOW_FAVORITE_NO_SPORT_MODAL = "SHOW_FAVORITE_NO_SPORT_MODAL",
    HIDE_FAVORITE_NO_SPORT_MODAL = "HIDE_FAVORITE_NO_SPORT_MODAL",

    SHOW_LOGIN_PERMISSION_MODAL = "SHOW_LOGIN_PERMISSION_MODAL",
    HIDE_LOGIN_PERMISSION_MODAL = "HIDE_LOGIN_PERMISSION_MODAL",

    SHOW_COMPLETE_PROFILE_MODAL = "SHOW_COMPLETE_PROFILE_MODAL",
    HIDE_COMPLETE_PROFILE_MODAL = "HIDE_COMPLETE_PROFILE_MODAL",

    SHOW_PROFILE_COMPLETED_MESSAGE_MODAL = "SHOW_PROFILE_COMPLETED_MESSAGE_MODAL",
    HIDE_PROFILE_COMPLETED_MESSAGE_MODAL = "HIDE_PROFILE_COMPLETED_MESSAGE_MODAL",
}